const services = [
  {
    icon: "ri-computer-line",
    tag: "24/7 Available",
    title: "Remote IT Support",
    description:
      "Instant remote access to diagnose and resolve software issues, system errors, and connectivity problems — no travel required.",
    image:
      "https://public.readdy.ai/ai/img_res/9ddd58b5cb22d985aa0f692e26f7d86f.jpg",
  },
  {
    icon: "ri-tools-line",
    tag: "Rapid Response",
    title: "Onsite IT Services",
    description:
      "Our certified engineers arrive at your location to handle hardware installations, network cabling, server setup, and hands-on troubleshooting.",
    image:
      "https://readdy.ai/api/search-image?query=IT%20engineer%20installing%20network%20equipment%20in%20server%20rack%20at%20business%20office%2C%20professional%20technician%20with%20tools%2C%20clean%20organized%20workspace%2C%20natural%20lighting&width=600&height=400&seq=service-onsite-001&orientation=landscape",
  },
  {
    icon: "ri-shield-keyhole-line",
    tag: "Proactive Protection",
    title: "Cybersecurity",
    description:
      "Comprehensive security audits, firewall configuration, endpoint protection, and employee training to keep your business safe from threats.",
    image:
      "https://readdy.ai/api/search-image?query=cybersecurity%20concept%20with%20digital%20lock%20and%20shield%20on%20dark%20background%2C%20glowing%20network%20nodes%2C%20abstract%20security%20visualization%2C%20professional%20technology%20aesthetic&width=600&height=400&seq=service-cyber-001&orientation=landscape",
  },
  {
    icon: "ri-cloud-line",
    tag: "Scalable Solutions",
    title: "Cloud Services",
    description:
      "Seamless migration to cloud platforms, ongoing management, backup solutions, and cost optimization for AWS, Azure, and Google Cloud.",
    image:
      "https://readdy.ai/api/search-image?query=cloud%20computing%20concept%20with%20floating%20data%20nodes%20and%20server%20connections%2C%20clean%20minimal%20technology%20visualization%2C%20soft%20blue%20and%20white%20tones%2C%20modern%20digital%20infrastructure&width=600&height=400&seq=service-cloud-001&orientation=landscape",
  },
  {
    icon: "ri-router-line",
    tag: "Always Connected",
    title: "Network Infrastructure",
    description:
      "Design, installation, and management of wired and wireless networks — from small offices to multi-site enterprise environments.",
    image:
      "https://readdy.ai/api/search-image?query=modern%20network%20infrastructure%20with%20routers%20switches%20and%20ethernet%20cables%20in%20organized%20server%20room%2C%20professional%20IT%20setup%2C%20clean%20and%20well-lit%20environment&width=600&height=400&seq=service-network-001&orientation=landscape",
  },
  {
    icon: "ri-settings-3-line",
    tag: "Fully Managed",
    title: "Managed IT Services",
    description:
      "Let us handle your entire IT environment — monitoring, maintenance, updates, and helpdesk — so you can focus on your business.",
    image:
      "https://readdy.ai/api/search-image?query=IT%20management%20dashboard%20on%20large%20monitor%20showing%20system%20health%20metrics%20and%20network%20monitoring%2C%20professional%20control%20room%20environment%2C%20modern%20technology%20workspace&width=600&height=400&seq=service-managed-001&orientation=landscape",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <div>
            <span className="text-teal-600 text-xs font-semibold tracking-widest uppercase mb-3 block">
              What We Offer
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
              Comprehensive IT<br />Solutions
            </h2>
          </div>
          <p className="text-gray-500 text-base leading-relaxed max-w-md lg:text-right">
            From day-to-day helpdesk support to full infrastructure management, SilentNet covers every aspect of your technology needs.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300 border border-gray-100"
            >
              {/* Image */}
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-teal-50 text-teal-600 text-lg">
                    <i className={service.icon} />
                  </div>
                  <span className="text-xs font-semibold text-teal-600 bg-teal-50 px-3 py-1 rounded-full">
                    {service.tag}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
              </div>
              {/* Bottom accent */}
              <div className="h-0.5 bg-teal-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
